import { Modal } from 'antd'
import approveImg from 'components/Images/duplicate.png'
import React from 'react'
const UpdatePopup = ({
  open,
  onCancel,
  onConfirm,
  loading = false,
  image,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  width = 770,
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
    >
      <div
        style={{
          width,
          borderRadius: 10,
          background: '#fff',
          padding: 40,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          
            <img
              src={approveImg}
              width={156}
              height={197}
              alt="modal"
            />

          <div
            style={{
              fontFamily: 'Plus Jakarta Sans',
              fontSize: 24,
              lineHeight: '41px',
              marginTop: 24,
              color: '#010E30',
            }}
          >
            Are you sure you want to update your current changes along with all other pending changes?
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 12,
              marginTop: 30,
            }}
          >
            <button
              disabled={loading}
              onClick={onCancel}
              style={{
                height: 38,
                padding: '9px 20px',
                borderRadius: 10,
                background: '#FBFAFF',
                color: '#3249D7',
                border: '1px solid #E3DEFF',
                cursor: 'pointer',
              }}
            >
              Cancel
            </button>

            <button
              disabled={loading}
              onClick={onConfirm}
              style={{
                height: 38,
                padding: '9px 20px',
                borderRadius: 10,
                background: '#3249D7',
                color: '#FBFAFF',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default UpdatePopup
